// レスポンシブ判定 & デバイス判定関数（PC,SP共通処理）
//-------------------------------------------------------------
function checkDeviceAndWidthFunc(){

  var pgwBrowser = $.pgwBrowser();
  var jsBr = pgwBrowser.browser.group;
  var jsBrVer = pgwBrowser.browser.group + pgwBrowser.browser.majorVersion;
  var jsOS = pgwBrowser.os.group;
  var jsOsVer = pgwBrowser.os.group + pgwBrowser.os.majorVersion;
  //console.info('横幅:' + pgwBrowser.viewport.width + 'px / 縦幅:' + pgwBrowser.viewport.height + 'px');
  //console.info(pgwBrowser.userAgent);
  $('html').addClass(jsBr + ' ' + jsBrVer + ' ' + jsOS + ' ' + jsOsVer);
}

function mq(device) {
  if (window.matchMedia('(max-width:768px)').matches && device == "sp") {
    return true;
  } else if (window.matchMedia('(min-width:769px)').matches && device == "pc") {
    return true;
  }
  return false;
}

// ウォーターマーク
//-------------------------------------------------------------
function consoleLogo(title) {
  var dir = location.href.split("/");
  var imgStyles = 'background: url(' + dir[0] + '//' + dir[2] + '/common/img/touch.png) no-repeat center 0;' +
    'background-size: 100% auto;' +
    'line-height: 64px;' +
    'padding: 64px;';
  var textStyles = 'font-family: "Montserrat",sans-serif;' +
    'letter-spacing: 0.12em;' +
    'font-weight: 800;' +
    'font-size: 12px;' +
    'color: #fff;';
  console.log('%c', imgStyles);
  console.log('%c' + title, textStyles);
};

// load判定関数（PC,SP共通処理）
//-------------------------------------------------------------
function loadedPageFunc (){

  var $pageBody = $('body');
  $pageBody.addClass('loaded');

}


//page top関数（PC,SP共通処理）
//-------------------------------------------------------------
function goToPageTopFunc($pageTopId){

  var $pageTopId = $($pageTopId);
  $pageTopId.click(function() {
    $("html, body").animate({scrollTop:0}, 500, "swing");
    return false;
  });

}

//ページ内スクロール関数（PC,SP共通処理）
//-------------------------------------------------------------
function smoothScrollMoveFunc(goToClassName){

  var $goToClassName = $(goToClassName);

  var headerHeight = $('.header').outerHeight(); //ヘッダー固定の場合は必要
  var urlHash = location.hash;
  if(urlHash) {
    $('body,html').stop().scrollTop(0);
    setTimeout(function(){
      var target = $(urlHash);
      var position = target.offset().top - headerHeight; //ヘッダー固定の場合は必要headerHeightが必要
      $('body,html').stop().animate({scrollTop:position}, 500);
    }, 100);
  }
  $goToClassName.click(function() {
    var href= $(this).attr("href");
    var target = $(href);
    var position = target.offset().top - headerHeight; //ヘッダー固定の場合は必要headerHeightが必要
    $('body,html').stop().animate({scrollTop:position}, 500);
  });

}


// --- ページの全データを読み込み後 ----------------------------------
$(window).on('load', function() {

  loadedPageFunc();
  checkDeviceAndWidthFunc();

});

// --- リサイズが走った場合 ----------------------------------------
$(window).on('resize', function(){

  checkDeviceAndWidthFunc();

});

// --- DOM生成後 -----------------------------------------------
$(function(){

  // 共通処理
  goToPageTopFunc('#pageTop');
  smoothScrollMoveFunc('a.scroll');

  // TOP PAGE
  if($('#topPage').length){
  }

  // PC or SP
  if (mq('sp')) {
  } else {
    console.log('pc')
  }

});
